import { IRtcPeer } from "@formant/core/model/IRtcPeer";
import { Peer } from "@formant/protos";

export function peerToRtcPeer(peer: Peer): IRtcPeer {
    return {
        userId: peer.getUserId()?.getValue(),
        deviceId: peer.getDeviceId()?.getValue(),
        organizationId: peer.getOrganizationId(),
        id: peer.getPeerId(),
        capabilities: [],
        capabilitySet: {},
    };
}
